import { cn } from '@/lib/utils'

interface ToggleProps {
  on: boolean
  onChange?: (v: boolean) => void
  disabled?: boolean
  className?: string
}

export function Toggle({ on, onChange, disabled, className }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      disabled={disabled}
      onClick={() => !disabled && onChange?.(!on)}
      className={cn(
        'relative inline-flex w-11 h-6 rounded-full transition-colors flex-shrink-0',
        on ? 'bg-emerald-500' : 'bg-slate-200',
        disabled && 'opacity-60 cursor-not-allowed',
        !disabled && 'cursor-pointer',
        className
      )}
    >
      <span
        className={cn(
          'absolute top-0.5 w-5 h-5 bg-white rounded-full transition-all shadow-sm',
          on ? 'right-0.5' : 'left-0.5'
        )}
      />
    </button>
  )
}
